import React, { useContext } from "react";
import {
  faBriefcase,
  faCashRegister,
  faHandHoldingDollar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Box, Collapse, Stack, Typography } from "@mui/material";
import { getRuta, isAccess } from "../../helpers/Helpers";
import { DataContext } from "../../context/DataContext";
import NavItem from "./NavItem";
import { sidebar } from "../../theme";

const Administracion = ({ drawerIsOpen }) => {
  const [open, setOpen] = React.useState(false);
  let rout = getRuta();
  const { access } = useContext(DataContext);
  return (
    <div>
      <Box
        onClick={() => setOpen(!open)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "13px",
          padding: "11px 12px",
          borderRadius: "11px",
          cursor: "pointer",
          color: sidebar.itemColor,
          "&:hover": { backgroundColor: "rgba(255,255,255,.06)", color: sidebar.userColor },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", fontSize: 19, color: "inherit", flexShrink: 0 }}>
          <FontAwesomeIcon icon={faBriefcase} fontSize="inherit" />
        </Box>
        <Typography sx={{ fontSize: 14.5, flex: 1, minWidth: 0 }}>Administración</Typography>
        {open ? <ExpandLessRoundedIcon sx={{ fontSize: 18 }} /> : <ExpandMoreRoundedIcon sx={{ fontSize: 18 }} />}
      </Box>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <Stack marginTop={0.3} paddingLeft={drawerIsOpen ? 2 : 0} spacing={0.3}>
          {isAccess(access, "CAJA VER") ? (
            <NavItem
              to={`${rout}/caja`}
              sub
              icon={<FontAwesomeIcon icon={faCashRegister} fontSize="inherit" />}
              label="Caja"
            />
          ) : null}

          {isAccess(access, "ADMON VER") ? (
            <NavItem
              to={`${rout}/gastos`}
              sub
              icon={<FontAwesomeIcon icon={faHandHoldingDollar} fontSize="inherit" />}
              label="Gastos"
            />
          ) : null}
        </Stack>
      </Collapse>
    </div>
  );
};

export default Administracion;
